import React from 'react';
import type NextGenReportsBurnupType from '@atlassian/jira-spa-apps-next-gen-reports-burnup/src/index-old.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';
import { getBoardId } from '../../../../common/index.tsx';

/** @deprecated remove when clean up fun-1595-migrate-burnup-report-to-relay-endpoint */
export const LazyNextGenBurnupReport = lazyForPaint<typeof NextGenReportsBurnupType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-next-gen-reports-burnup", jiraSpaEntry: "next-gen-reports-burnup" */ '@atlassian/jira-spa-apps-next-gen-reports-burnup/src/index-old.tsx'
		),
	),
);

type Props = RouteContext;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default ({ location, match }: Props) => (
	<LazyPage
		Page={LazyNextGenBurnupReport}
		pageId={`next-gen-reports-burnup-${getBoardId({ location, match })}`}
		shouldShowSpinner={false}
	/>
);
